import { Delete, KeyboardArrowDown } from '@mui/icons-material';
import { ListItemIcon, ListItemText, Menu } from '@mui/material';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BulkActionButton, BulkActionMenuItem } from '~/components/bulk-actions';
import { useBulkActionIds } from '~/hooks/unique-id';

export type BulkActionsProps = {
  onDelete: () => void;
};

export const BulkActions = ({ onDelete }: BulkActionsProps) => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [open, setOpen] = useState(false);
  const { buttonId, menuId } = useBulkActionIds();

  return (
    <>
      <BulkActionButton
        ref={buttonRef}
        disableRipple
        id={buttonId}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={() => setOpen(true)}
      >
        {t('common.buttons.bulk_actions')}
        <KeyboardArrowDown />
      </BulkActionButton>
      <Menu
        id={menuId}
        anchorEl={buttonRef.current}
        open={open}
        onClose={() => setOpen(false)}
        MenuListProps={{
          'aria-labelledby': buttonId,
        }}
      >
        <BulkActionMenuItem
          onClick={() => {
            onDelete();
            setOpen(false);
          }}
        >
          <ListItemIcon>
            <Delete color="error" />
          </ListItemIcon>
          <ListItemText primaryTypographyProps={{ color: 'error' }}>
            {t('common.actions.delete')}
          </ListItemText>
        </BulkActionMenuItem>
      </Menu>
    </>
  );
};
